import { ITypography } from "../../data/interfaces";

export default function getTypographyStyle (typoValue: ITypography | undefined): string {
    if(!typoValue || !Object.keys(typoValue).length) {
        return ""
    }
    return Object.keys(typoValue).map((key: string) => getSingleTypoStyle( typoValue[key as  keyof ITypography], key as  keyof ITypography)).join("")
}

export function getSingleTypoStyle(value: any, field: keyof ITypography): string {
    if(typeof value === "undefined") {
        return ""
    }
    switch(field) {
        case "font_size":
            return `font-size: ${ value }px!important;`
        case "text_align":
            return `text-align: ${ value }!important;`
        case "font":
            return `font-family: ${ value }!important;`
        case "font_case":
            return `text-transform: ${ value }!important;`
        case "line_height":
            return `line-height:  ${ value }!important;`
        case "letter_spacing":
            return `letter-spacing: ${ value }px!important;`
        case "font_weight":
            return `font-weight: ${ value }!important;`
        case "text_color":
            return value.indexOf("gradient") > 0 
                ?
                `color: transparent!important; 
                background-image: ${ value }!important;
                background-clip: text!important;
                will-change: transform!important;
                background-position: center center!important;`
                :
                `color: ${ value}!important;`
            
    }
}